export const DURATION_OF_USE = {
  'less-than-month': 'Меньше месяца',
  'month-half-of-year': 'От месяца до полугода',
  'half-of-year-one-year': 'От полугода до года',
  'more-than-year': 'Больше года',
};

export type DurationOfUseType = keyof typeof DURATION_OF_USE;

export const DURATION_OF_USE_BY_LABEL = Object.fromEntries(
  Object.entries(DURATION_OF_USE).map(([key, label]) => [label, key]),
) as Record<string, DurationOfUseType>;

export const APP_MAIN_ID = 'app-main';
export const BRAND_CHARACTERISTICS_KEY = '06575';
export const HIDE_CALCULATOR_INTERNAL_ID = 'hide_calculator';
export const HIDE_BRANDS_INTERNAL_ID = 'hide_brands';
export const HIDE_BOX_M2_SUGGEST_ID = 'hide_box_m2_suggest';

export const REVIEW_FORM_MAX_TEXT_LENGTH = 1500;
export const REVIEWS_FORM_HASH = '#reviews-form';

export const ENABLE_SERVICES_DISCOUNT = 'enable_services_discount';

export const REMOTE_TIMEOUT_DEFAULT = 2000;

export const DISABLE_LOYALTY_REWARDS_EXPERIMENT = 'loyalty_rewards_disable_pdp';

export const LAMINATE_CALCULATOR_IDS = [
  '66d04df7c1480f7c1f38d2c0',
  '66d0448a206ce857b374a704',
  '66d043db0f8f5b1e368859e6',
];

export const LAMINATE_SAVE_PROJECT_EXPERIMENT = 'calculators_configuration_laminat_save_project';
export const SHOPPING_LIST_COOKIE_KEY = 'shoppingList';

export const GROUP_OF_VARIANTS = 'groupOfVariants';
export const SINGLE_PRODUCT = 'singleProduct';

export const KK_MONTHS = [
  'қаңтар',
  'ақпан',
  'наурыз',
  'сәуір',
  'мамыр',
  'маусым',
  'шілде',
  'тамыз',
  'қыркүйек',
  'қазан',
  'қараша',
  'желтоқсан',
] as const;
